module.exports = __webpack_public_path__ + "img/084.794ae959.jpeg";